// extracted by mini-css-extract-plugin
module.exports = {"dots":"QuickBookingDots_dots__6gGOg","dots-skeleton":"QuickBookingDots_dots-skeleton__z_LIz"};